import { requestGet } from '@/common/request';

export interface poolHeaderParams {
  tibaoId: string | undefined | null;
  poolId: string | undefined | null;
}

export interface poolHeaderRes {
  ret: string;
  msg: string;
  data: {
    name: string;
    otherSystemGroupId: string;
    gatherType: string;
    description: string;
  };
}

//
export async function poolHeader(params: poolHeaderParams): Promise<poolHeaderRes> {
  return await requestGet('/room/poolHeader', params);
}
